import React, { Component } from 'react';
import { Grid, Cell, TextField, SelectionControlGroup } from 'react-md';
import { Link, Redirect } from 'react-router-dom';
import validate from 'validate.js';

import './Estimate.css';

import { state, isStateEmpty } from '../services/state';

validate.validators.presenceIfEstimated = function(
	value,
	options,
	key,
	attributes
) {
	if (attributes.hasEstimate === true || attributes.hasEstimate === 'true') {
		if (!value) {
			return 'must be present';
		}
	}
};

class Estimate extends Component {
	constraints = {
		hasEstimate: {
			presence: { allowEmpty: false }
		},
		estimateNumber: {
			presenceIfEstimated: true
		}
	};

	constructor(props) {
		super(props);
		this.state = {
			hasEstimate: state.hasEstimate,
			estimateNumber: state.estimateNumber
		};
	}

	handleRadioChange = change => {
		state.hasEstimate = change;
		this.setState({
			hasEstimate: change
		});
	};

	handleTextChange = change => {
		state.estimateNumber = change;
		this.setState({
			estimateNumber: change
		});
	};

	isValid = () => {
		this.validation = validate(state, this.constraints);
		return !this.validation;
	};

	nextClick = event => {
		if (!this.isValid()) {
			event.stopPropagation();
			event.preventDefault();
			return false;
		}
	};

	render() {
		if (isStateEmpty()) {
			return <Redirect to="/" />;
		}

		const { hasEstimate, estimateNumber } = this.state;
		const isValid = this.isValid();

		return (
			<div className="Estimate">
				<Grid>
					<Cell
						size={6}
						tabletOffset={1}
						desktopOffset={3}
						className="title-wrapper"
					>
						<h2 className="sub-section-title">
							Has your project been estimated?
						</h2>
					</Cell>
				</Grid>
				<Grid>
					<Cell
						size={6}
						tabletOffset={1}
						desktopOffset={3}
						className="estimate-options-wrapper"
					>
						<SelectionControlGroup
							id="estimate-selection"
							name="estimate-selection"
							type="radio"
							defaultValue={this.state.hasEstimate}
							inline={true}
							controls={[
								{
									label: 'Yes',
									value: 'true'
								},
								{
									label: 'No',
									value: 'false'
								}
							]}
							value={hasEstimate}
							onChange={this.handleRadioChange}
							checkedRadioIcon={
								<div className="radio-icon checked-radio-icon" />
							}
							uncheckedRadioIcon={
								<div className="radio-icon unchecked-radio-icon" />
							}
						/>
					</Cell>
				</Grid>
				<Grid>
					<Cell
						size={6}
						tabletOffset={1}
						desktopOffset={3}
						className={
							hasEstimate === 'true'
								? 'title-wrapper'
								: 'title-wrapper hidden'
						}
					>
						<h2 className="sub-section-title">
							What is your estimate #?
						</h2>
					</Cell>
				</Grid>
				<Grid>
					<Cell
						size={6}
						tabletOffset={1}
						desktopOffset={3}
						className={
							hasEstimate === 'true'
								? 'estimate-form-wrapper'
								: 'estimate-form-wrapper hidden'
						}
					>
						<TextField
							id="estimate-number"
							label="Your estimate #"
							value={estimateNumber}
							onChange={this.handleTextChange}
						/>
					</Cell>
				</Grid>
				<Grid className="next-wrapper">
					<Cell size={6} tabletOffset={1} desktopOffset={3}>
						<Link to="/info" className="primary-button">
							<i className="uploader-icon uploader-icon-Previous-Arrow" />{' '}
							Previous
						</Link>
						<Link
							to="/contacts"
							onClick={this.nextClick}
							className={`primary-button ${
								isValid ? '' : 'disabled'
							}`}
						>
							Next{' '}
							<i className="uploader-icon uploader-icon-Next-Arrow" />
						</Link>
					</Cell>
				</Grid>
			</div>
		);
	}
}

export default Estimate;



// WEBPACK FOOTER //
// ./src/pages/Estimate.js